import cx from 'classnames';
import PropTypes from 'prop-types';

import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { TEMPLATE_BUILDER_PARAMS } from 'src/data/template';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  customToolData: PropTypes.shape({
    templateType: PropTypes.string,
  }),
};

const defaultProps = {
  className: '',
  customToolData: null,
};

export const GenerationToolTag = ({ className, customToolData }) => {
  const styles = useStyles();

  const { title, bgColor } = getTemplateTagsSettings({
    customToolData,
  });

  return (
    <CustomTypography
      className={cx(className, styles.root)}
      style={{ backgroundColor: bgColor }}
      variant={TYPOGRAPHY_VARIANT.medium12}
    >
      {title}
    </CustomTypography>
  );
};

GenerationToolTag.displayName = 'GenerationToolTag';
GenerationToolTag.propTypes = propTypes;
GenerationToolTag.defaultProps = defaultProps;

const getTemplateTagsSettings = ({ customToolData }) => {
  if (customToolData?.templateType === TEMPLATE_BUILDER_PARAMS.csv) {
    return {
      title: 'CSV Template',
      bgColor: '#FAE8FF',
    };
  }

  return {
    title: 'Short-form editor',
    bgColor: '#E9F0FE',
  };
};
